import { useNavigate } from 'react-router-dom'

import type { ClosePortalFn } from 'modules/core/components/Portal/useCloseProxy'
import useAsyncAction from 'modules/core/hooks/useAsyncAction'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'
import type { Adapter } from 'modules/core/lib/mobx-rest/types'

import { useEmployeesImporter } from 'modules/employees/lib/employeesImporterContext'

const IMPORTS_PATH = '/onboarding_importer/imports_custom_tables'
interface Props {
  api: Adapter
}

const useProcessFile = ({ api }: Props) => {
  const navigate = useNavigate()
  const { navigation } = useNavigation()
  const importer = useEmployeesImporter()

  const { running, performAction: onSubmit } = useAsyncAction(
    async (closePortal: ClosePortalFn) => {
      const file = importer.files[0]

      if (!file) return

      const payload = await api.post(IMPORTS_PATH, {
        file,
      })

      const { token, employees, attributes, custom_fields: customFields } = payload
      importer.setEmployees({
        employees,
        attributes,
        customFields,
        isOverlimited: payload.is_overlimited,
        newEmployees: payload.new_employees,
        currentSeats: payload.current_seats,
        maxEmployeesAllowedImport: payload.max_employees_allowed_import,
      })
      importer.setToken(token)
      closePortal()
      navigate(navigation.employees.import.fullPath())
    },
    {
      successMessage: i18n.t('import.success'),
    }
  )

  return {
    running,
    onSubmit,
  }
}

export default useProcessFile
